// Action types
const SET_CALCULATION_TITLE = "divorcepath-ui/src/ducks/breadcrumb/SET_CALCULATION_TITLE";
const SET_CALCULATION_TYPE = "divorcepath-ui/src/ducks/breadcrumb/SET_CALCULATION_TYPE";
const CLEAR_CALCULATION_TITLE = "divorcepath-ui/src/ducks/breadcrumb/CLEAR_CALCULATION_TITLE";

// Initial state
const initialState = {
  calculationTitle: null,
  showSpousalSupport: false,
  showChildSupport: false,
};

// Reducer
const breadcrumbReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CALCULATION_TITLE:
      return { ...state, calculationTitle: action.payload };
    case SET_CALCULATION_TYPE:
      return {
        ...state,
        showSpousalSupport: action.payload.showSpousalSupport,
        showChildSupport: action.payload.showChildSupport,
      };
    case CLEAR_CALCULATION_TITLE:
      return {
        ...state,
        calculationTitle: null,
        showSpousalSupport: false,
        showChildSupport: false,
      };
    default:
      return state;
  }
};

// Action creators
export const setCalculationTitle = (title) => ({
  type: SET_CALCULATION_TITLE,
  payload: title,
});

export const setCalculationType = (showSpousalSupport, showChildSupport) => ({
  type: SET_CALCULATION_TYPE,
  payload: { showSpousalSupport, showChildSupport },
});

export const clearCalculationTitle = () => ({
  type: CLEAR_CALCULATION_TITLE,
});

export default breadcrumbReducer;
